module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/registry-list-460be48a90ef3e5d7f0a9dee5d9ca41b.png";